export const PREFIX = 'AddOnAiFeature';
export const ADD_ON_AI_FEATURE_LLM_CONFIGURATION = PREFIX + '.LlmConfiguration';
export const ADD_ON_AI_FEATURE_MODEL = PREFIX + '.Model';
export const ADD_ON_AI_FEATURE_MODEL_NAME = PREFIX + '.ModelName';
export const ADD_ON_AI_FEATURE_REASONING_EFFORT = PREFIX + '.ReasoningEffort';

export const ADDON_AI_FIELD_NAMES = {
  llmConfiguration: 'llmConfiguration',
  llmModel: 'llmModel',
  llmCustomModel: 'llmCustomModel',
  reasoningEffort: 'reasoningEffort',
};
